import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';
import { options, selectorBulletPagination } from './shared/options';

document.addEventListener('DOMContentLoaded', () => {
  const swiperBulletPaginationMount = document.querySelector(selectorBulletPagination);
  if (swiperBulletPaginationMount) {
    const defaultOptions = {
      ...options,
      ...{
        autoplay: {
          delay: 7000,
        }
      }
    };

    const config = {
      ...defaultOptions,
      ...{
        modules: [
          Autoplay,
          Pagination
        ],
        slidesPerView: 1,
        speed: 600,
        pagination: {
          el: '.custom-swiper-pagination',
          bulletActiveClass: 'custom-swiper-pagination-bullet-active',
          bulletClass: 'custom-swiper-pagination-bullet',
          clickableClass: 'custom-swiper-pagination-clickable',
          type: 'bullets',
          clickable: true,
        }
      }
    };

    new Swiper(selectorBulletPagination, config);
  }
});
